/** Optional first two rows of preview reads for the desktop Dashboard overview. */
export function dashboardOverviewPreviewParams(): { include_previews?: true } {
  return typeof window !== 'undefined' && window.innerWidth >= 1024
    ? { include_previews: true }
    : {};
}

export function dashboardOverviewOpeningRequest(): string {
  const path = '/dashboards?page=1&page_size=24&sort_by=updated_at&sort_dir=desc';
  return dashboardOverviewPreviewParams().include_previews ? `${path}&include_previews=true` : path;
}
